import MeApi from "@/apis/me";
import Cookies from "js-cookie";
import _ from "lodash";
import { defineStore } from 'pinia'
import { useAlertStore } from './alert'
import axios from "axios";

export const useAuthUserStore = defineStore('authUser', {
    state: () => {
        return {user: null}
    },
    getters: {
        check(state) {
            return (
                !!state.user ||
                typeof Cookies.get(import.meta.env.VITE_SESSION_COOKIE_NAME) !==
                    "undefined"
            );
        },
        isAuthenticated(state) {
            return (
                !!state.user ||
                typeof Cookies.get(import.meta.env.VITE_SESSION_COOKIE_NAME) !==
                    "undefined"
            );
        },
        id(state) {
            return state.user?.id;
        }
    },
    actions: {
        resetAuthState() {
            this.user = null;
        },

        async getUser(authIncludes) {
            const alertStore = useAlertStore();
            try {
                const res = await MeApi.get(authIncludes);
                this.setUser(res.data.data);
            } catch (err) {
                if (!this.user && err.response.status === 401) {
                    return;
                }
                this.setUser(null);
                if (this.user && err.response.status === 401) {
                    return alertStore.error( {
                        timeout: 10000,
                        message: "You've been logged out"
                    });
                }
                alertStore.error( {
                    timeout: 7000,
                    message: "Error loading user"
                });
            }
        },

        setUser(user) {
            this.user = user;
        },

        setSelectedChild(child) {
            if (!this.user || this.user.type !== "parent") {
                throw new Error("Trying to set selected child for non-parent");
            }
            _.set(this.user, "related.selected_child", child);
        },

        setAcceptedToolUsage() {
            if (!this.user || this.user.type !== "parent") {
                throw new Error("Trying to set accepted tool usage for non-parent");
            }

            axios.create({baseURL: "https://" +
                window.location.host + import.meta.env.VITE_API_PATH + "/parent", headers: {"X-Requested-With": "XMLHttpRequest"}})
                .post("applicationaccess").then(
                () => {
                    this.user.settings.accepted_tool_usage = true;
                });
        },

        logout() {
            const alertStore = useAlertStore();
            const isParent = this.user?.type === 'parent';
            axios.create({baseURL: "https://" +
                window.location.host, headers: {"X-Requested-With": "XMLHttpRequest"}})
                .post("/auth/logout").then(
                res => {
                    if (!res.data.success) {
                        alertStore.error({
                            timeout: 10000,
                            message:
                                res.data.data.message ??
                                (isParent ? "pp.errorsigningout" : "myfiles.app.logouterror"),
                            closeable: true
                        });
                        return;
                    }

                    this.user = null;
                    if (isParent){
                        this.router.push({ name: "login" });
                    } else {
                        let redirect = "/";
                        if (
                            Object.prototype.hasOwnProperty.call(
                                res.data.data,
                                "redirect"
                            ) &&
                            res.data.data.redirect !== null
                        ) {
                            redirect = res.data.data.redirect;
                        }
                        location.href = redirect;
                    }
                },
                err => {
                    if (!err.shouldHandle) {
                        return;
                    }
                    alertStore.error({
                        timeout: 7000,
                        message: isParent ? "pp.errorsigningout" : "myfiles.app.logouterror",
                        closeable: true
                    });
                }
            );
        }
    },
});
